import * as RadixTooltip from "@radix-ui/react-tooltip";
import { type ReactNode } from "react";
import { cn } from "@/lib/cn";
import { BfrsPortalScope } from "@/components/ui/providers/BfrsProvider";
import { floatingCollisionPadding, floatingLayerClassName, tooltipContentCollisionClassName } from "../overlayPositioning";

export type TooltipProps = {
  content: ReactNode;
  children: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  delayDuration?: number;
  /** When true, the tooltip never opens but the trigger stays mounted unchanged. */
  disabled?: boolean;
};

export function Tooltip({ content, children, side = "top", delayDuration = 350, disabled = false }: TooltipProps) {
  return (
    <RadixTooltip.Provider delayDuration={delayDuration}>
      <RadixTooltip.Root open={disabled ? false : undefined}>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <BfrsPortalScope>
            <RadixTooltip.Content
              side={side}
              sideOffset={6}
              collisionPadding={floatingCollisionPadding}
              className={cn(
                floatingLayerClassName,
                "bfrs-rounded-md bfrs-bg-text-primary bfrs-px-3 bfrs-py-2 bfrs-text-xs bfrs-leading-5 bfrs-text-text-inverse bfrs-shadow-elevated bfrs-animate-content-in",
                tooltipContentCollisionClassName
              )}
            >
              {content}
              <RadixTooltip.Arrow className="bfrs-fill-text-primary" />
            </RadixTooltip.Content>
          </BfrsPortalScope>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}
